export class ShuttleStatusLog {
}
//# sourceMappingURL=shuttle-status-log.js.map